const API = process.env.REACT_APP_BACKEND_URL;

export async function exchangeAdminSession(sessionId) {
  const res = await fetch(`${API}/api/admin/auth/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ session_id: sessionId }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Login failed");
  }
  return res.json();
}

export async function getAdminMe() {
  const res = await fetch(`${API}/api/admin/auth/me`, { credentials: "include" });
  if (!res.ok) return null;
  return res.json();
}

export async function adminLogout() {
  await fetch(`${API}/api/admin/auth/logout`, { method: "POST", credentials: "include" });
}

export function startAdminLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/admin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export async function fetchAdminOrders(paymentId) {
  const url = new URL(`${API}/api/admin/orders`);
  if (paymentId) url.searchParams.set("payment_id", paymentId);
  const res = await fetch(url.toString(), { credentials: "include" });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Could not load orders");
  }
  return res.json();
}
